import type { Confidence } from "@memorang/types";
import SubmitAnswerDynamic from "./SubmitAnswerDynamic";
import SubmitAnswerStatic from "./SubmitAnswerStatic";

type Props = {
	type?: "dynamic" | "static";
	handleConfidenceProvided: (confidence: Confidence) => void;
	handleAiFeedbackProvided: (confidence: Confidence) => void;
	handleTrackConfidenceClick: (confidence: Confidence) => void;
	handleGenerateFeedback?: (callback: () => void) => Promise<void>;
	cta: string;
};
const SubmitAnswer = ({
	type = "static",
	handleConfidenceProvided,
	handleAiFeedbackProvided,
	handleTrackConfidenceClick,
	handleGenerateFeedback,
	cta,
}: Props) => {
	if (type === "static") {
		return (
			<SubmitAnswerStatic
				handleConfidenceProvided={handleConfidenceProvided}
				handleTrackConfidenceClick={handleTrackConfidenceClick}
			/>
		);
	}
	return handleGenerateFeedback ? (
		<SubmitAnswerDynamic
			handleConfidenceProvided={handleConfidenceProvided}
			handleAiFeedbackProvided={handleAiFeedbackProvided}
			handleGenerateFeedback={handleGenerateFeedback}
			cta={cta}
		/>
	) : null;
};

export default SubmitAnswer;
